exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-qty span[data-v-0fd1c4ef] {\n  top: 2px;\n}\n@media (max-width: 991px) {\n.cart-qty span[data-v-0fd1c4ef] {\n    top: 1px;\n}\n}", ""]);

// exports
